import DetailCard from './DetailCard';

export default DetailCard;
